<template>
  <div class="table13">
    <el-table :data="list" height="850" style="width: 100%" ref="table">
      <el-table-column prop="" label="基金" sortable>
        <template slot-scope="scope">
          <div style="font-size: 15px; color: #333333">
            {{ scope.row.ths_convertible_debt_short_name_cbond }}
          </div>
          <div style="font-size: 13px; color: #999999">
            {{ scope.row.code}}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="that_bond_close_price_cbond" label="最后价格" align="center" sortable>
        <template slot-scope="scope">
          {{scope.row.that_bond_close_price_cbond || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="ths_latest_trade_date_bond" label="赎回日" align="center" sortable>
        <template slot-scope="scope">
          {{scope.row.ths_latest_trade_date_bond || '--'}}
        </template>        
      </el-table-column>
      <el-table-column prop="ths_bond_balance_cbond" label="剩余规模(亿元)" align="center" sortable>
        <template slot-scope="scope">
          {{scope.row.ths_bond_balance_cbond || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="resale_scale" label="回售规模(亿元)" align="center" sortable>
        <template slot-scope="scope">
          {{scope.row.resale_scale || '--'}}
        </template>        
      </el-table-column>
      <el-table-column prop="ths_issue_total_amt_cbond" label="发行规模(亿元)" align="center" sortable>
        <template slot-scope="scope">
          {{scope.row.ths_issue_total_amt_cbond || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="ths_online_issue_date_cbond" label="发行日期" align="center" sortable>
        <template slot-scope="scope">
          {{scope.row.ths_online_issue_date_cbond || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="ths_latest_trade_date_bond" label="最后交易日" align="center" sortable>
        <template slot-scope="scope">
          {{scope.row.ths_latest_trade_date_bond || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="duration" label="存续年限(年)" align="center" sortable>
        <template slot-scope="scope">
          {{scope.row.duration || '--'}}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {quitCbondList} from '../../../http/index.js'
export default {
  data() {
    return {
      list:[],
      page:1,
      page_number:20,
      sortObj:{},
    };
  },
    mounted() {
    this.getlist()
    // 获取需要绑定的table
    this.dom = this.$refs.table.bodyWrapper
    this.dom.addEventListener('scroll', () => {
        // 滚动距离
        let scrollTop = this.dom.scrollTop
        let canshu = 350 * this.page
        console.log(canshu);
        console.log(scrollTop);
        if(scrollTop > canshu){
          this.getMore()
        }
    })
  },
  methods:{
    getMore() {
      this.page++
      this.getlist()
    },
    getlist(){
      let obj = this.sortObj
      let params = Object.assign({},{page:this.page,page_number:this.page_number},obj)
      quitCbondList(params).then((res)=>{
        if(this.page == 1){
          this.list = res.data.list
        }else{
          this.list = this.list.concat(res.data.list)
        }
       
      })
    },
    sortChange(a){
      this.page = 1
      this.list = []
      let canshu1 = a.prop
      let canshu2 
      if(a.order == 'ascending'){
        canshu2 = 'asc'
      }else if(a.order == 'descending'){
        canshu2 = 'desc'
      }else{
        canshu2 = null
      }
      if(canshu2 == null){
        this.sortObj = {}
        this.getlist()
      }else{
        let obj = {sort: `${canshu1} ${canshu2}`}
        this.sortObj = obj
        this.getlist()
      }
    }
  }
};
</script>

<style scoped>
.table13 {
  min-width: 1427px;
  position: relative;
}

th img {
  width: 8px;
  height: 15px;
  vertical-align: middle;
  margin-left: 6px;
}
td img {
  cursor: pointer;
  width: 20px;
  height: 20px;
}

.ssd {
  background-color: #539cff;
  font-size: 10px;
  height: 13px;
  line-height: 13px;
  border-radius: 3px;
  color: #fefefe;
  padding: 0 5px;
}

i {
  font-style: normal;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
.fontSize16 {
  font-size: 16px;
}
.colorRed {
  color: #fd4c4c;
}
.colorBlue {
  color: #4372ba;
}
.colorGreen {
  color: #41b357;
}
.BackColorGreen {
  background-color: #41b357;
}
.BackColorBlue {
  background-color: #4372ba;
}
.table13 /deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
.table13 /deep/ .cell{
  padding: 0;
}
.table13 /deep/ .el-table th.el-table__cell>.cell{
  padding:  0;
}
</style>